import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import '../containers/Goal/Evaluation.css'

export default function EvaluationLog({ LogEvaluation, LogToImprove, ThingsToImprove, Close, LogTotal }) {

    const [evaluation, setEvaluation] = useState([])
    const [toImprove, setToImprove] = useState([])
    const [ThingsToImproveMaster, setThingsToImproveMaster] = useState([])
    const [show, setshow] = useState(false)
    const [total, setTotal] = useState([])


    useEffect(() => {
        

        if (LogEvaluation !== undefined && LogEvaluation !== null) setEvaluation(...LogEvaluation)
        if (LogToImprove !== undefined && LogToImprove !== null) setToImprove(LogToImprove)
        if (ThingsToImprove !== undefined && ThingsToImprove !== null) setThingsToImproveMaster(ThingsToImprove)
        if (LogTotal !== undefined && LogTotal !== null) setTotal(LogTotal)
        $('body').addClass('removeScroll');
        setshow(true)
    }, [])

    const bindData = () => {
        let data = [];
        toImprove.map((ev) => {
            
            if (typeof ev === 'string') {
                data.push(ev);
            } else {
                ThingsToImproveMaster.map((ti) => {
                    if (ti.id === ev) {
                        data.push(ti.value);
                    }
                });
            }
        });

        return data.map((datum) => {
            return (
                <div className="accordion-item my-2 border-0 px-0 performance-table">
                    <label className="form-check-label form-readonly-label font-12 medium-text table-inlinetext-clr pb-3">
                        <img src="/Images/bulletedlisticon.svg" className="me-2" />
                        {datum}
                    </label>
                </div>
            );
        });
    };

    return (
        // <div className="modal fade" id="EvaluationLog" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="EvaluationLogLabel" style={{ display: show ? 'none' : 'block' }} aria-hidden="true" >
        <div className={show ? `modal fade show d-block` : `modal fade d-none`} id="EvaluationLog" tabIndex={-1} data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="EvaluationLogLabel" style={{ backgroundColor: 'rgba(0,0,0,0.6)', overflow: 'hidden' }}>
            <div className="modal-dialog performance-popup">
                <div className="modal-content">
                    <div className="modal-header px-5">
                        <h5 className="modal-title font-24 bold-text text-blue" id="exampleModalLabel">
                            Performance Evaluation
                        </h5>
                        <a onClick={() => { $('body').removeClass('removeScroll'); setshow(false); Close(false) }} data-bs-dismiss="modal" className="text-decoration-none">
                            <img src="/Images/close-icon.svg" />
                        </a>
                    </div>
                    <div className="modal-body px-5 logscroll">
                        {evaluation.length > 0 ? <div className="col-md-12 px-0 border-end">
                            <h5 className="border border-end-0 border-start-0 tt-bold font-15 ps-4 py-4 mb-0 border-top-0">
                                Evaluation
                            </h5>
                            {evaluation.map(eva => {
                                return (
                                    <>
                                        <div className="row ps-3 m-0 pt-3">
                                            <div className="col-md-8">
                                                <h6 className="font-12 bold-text pb-0">{eva.heading}</h6>
                                            </div>
                                            <div className="col-md-2 text-center">
                                                <h6 className="font-12 bold-text text-blue">Rating
                                                    {eva.heading == 1 ? <span>
                                                        <img className='ms-1' src="/Images/help.svg" title="Ratings based on the total 
                                                                        1. Does not Meet Expectations
                                                                        2. Below Expectations
                                                                        3. Meets Expectations
                                                                        4. Sometimes Exceeding Expectations
                                                                        5. Always Exceeding Expectation" alt="help-icon" />
                                                    </span> : null}
                                                </h6>
                                            </div>
                                            <div className="col-md-2 text-center">
                                                <h6 className="font-12 bold-text text-blue text-blue">Total</h6>
                                            </div>
                                        </div>
                                        <div className="row ps-3 m-0 pt-0">
                                            <div className="col-md-8">
                                                <p className="font-12 medium-text text-break text-wrap table-inlinetext-clr">
                                                    {/* {evaluation[0]?.description}
                                                     */}
                                                    {eva.description}
                                                </p>
                                            </div>
                                            <div className="col-md-2 text-center align-self-center">
                                                <p className="font-14 bold-text text-blue">
                                                    {eva.headingrating} * <span>
                                                        {/* {evaluation[0]?.rating} */}
                                                        {eva.rating}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="col-md-2 text-center align-self-center">
                                                <p className="font-14 bold-text text-blue">
                                                    {/* {evaluation[0]?.total} */}
                                                    {eva.total}

                                                </p>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                            <div className="row ps-3 m-0 pt-3">
                                <div className="col-md-10 text-end align-self-center">
                                    <p className="font-14 bold-text text-blue pe-4">Total</p>
                                </div>
                                <div className="col-md-2 text-center align-self-center">
                                    <p className="font-14 bold-text text-blue ">{total[0]?.grand_total}</p>
                                </div>
                            </div>
                            <div className="row ps-3 m-0 pt-3">
                                <div className="col-md-10 text-end">
                                    <p className="font-14 bold-text text-blue align-self-center pe-4">
                                        Rating based on evaluation
                                        <span>

                                            <img className='ms-1' src="/Images/help.svg" title="
                                                                        Ratings based on the total 
                                                                        44-50 = A+
                                                                        37-43 = A-
                                                                        30-36 = B+
                                                                        24-30 = B-
                                                                        17-23 = C+
                                                                        10-16 = C-"
                                                alt="help-icon" />
                                        </span>
                                    </p>
                                </div>
                                <div className="col-md-2 text-center px-2">
                                    <>
                                        <p className="card-text tt-bold font-18 text-skyblue">
                                            {total[0]?.grand_rating ? <img
                                                src={
                                                    !total[0]?.grand_rating
                                                        ? null : total[0]?.grand_rating.includes('+') ? `/Images/${total[0]?.grand_rating?.slice(0, -1)}_plus.png`
                                                            : total[0]?.grand_rating.includes('-') ? `/Images/${total[0]?.grand_rating?.slice(0, -1)}_minus.png` : null
                                                }
                                                className="emoji-sty  me-2"
                                                alt="excited-emoji"
                                            ></img> : null}
                                            {total[0]?.grand_rating}
                                        </p>
                                    </>
                                </div>
                            </div>
                        </div> : null}
                        {toImprove.length > 0 ? <div id='accordionExampleLog' className="accordion-item my-2 border-0 px-0 performance-table">
                            <h2 className="accordion-header mb-2 px-0 py-2 shadow-sm" id="thingstoimprovelog">
                                <button
                                    className="accordion-button-custom collapsed border-0 white-bg ps-3 pb-3 bold-text font-15"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapsethreelog"
                                    aria-expanded="true"
                                    aria-controls="collapsethreelog"
                                >
                                    Things to Improve
                                </button>
                            </h2>
                            <div
                                id="collapsethreelog"
                                className="accordion-collapse collapse"
                                aria-labelledby="thingstoimprovelog"
                                data-bs-parent="#accordionExampleLog"
                            >
                                <div className="accordion-body px-5">
                                    <div className="form-check my-1">{bindData()}</div>
                                </div>
                            </div>
                        </div> : null}

                    </div>
                </div>
            </div>
        </div>)
}
